import Http from './Http'

export default {
    async getLiveblog(match_id, params = {}) {
        const query = new URLSearchParams(params).toString()
        const suffix = query ? `?${query}` : ''
        return await Http.get(`/football/matches/${match_id}/liveblog${suffix}`)
    },
    async createLiveblog(match_id, data) {
        if (data instanceof FormData) {
            return await Http.post(`/football/matches/${match_id}/liveblog`, data, {
                headers: { 'Content-Type': 'multipart/form-data' },
            })
        }
        return await Http.post(`/football/matches/${match_id}/liveblog`, data)
    },
    async updateLiveblog(match_id, event_id, data) {
        if (data instanceof FormData) {
            return await Http.patch(`/football/matches/${match_id}/liveblog/${event_id}`, data, {
                headers: { 'Content-Type': 'multipart/form-data' },
            })
        }
        return await Http.patch(`/football/matches/${match_id}/liveblog/${event_id}`, data)
    },
    async reorderLiveblog(match_id, event_id, order) {
        return await Http.patch(`/football/matches/${match_id}/liveblog/${event_id}`, {
            order,
            reorder: true,
        })
    },
    async deleteLiveblog(match_id, event_id) {
        return await Http.delete(`/football/matches/${match_id}/liveblog/${event_id}`)
    },
    async importEvents(match_id, data) {
        return await Http.post(`/football/matches/${match_id}/liveblog/import-events`, data)
    },
    async getEventTypes() {
        return await Http.get('/football/event_types')
    },
    async getEventReasons() {
        return await Http.get('/football/event_reasons')
    },
    async getMatchPeriods(params = {}) {
        return await Http.get('/football/match_period', { params })
    },
    async getTimelineMode(match_id) {
        return await Http.get(`/football/matches/${match_id}/timeline-mode`)
    },
    async setTimelineMode(match_id, timeline_mode) {
        return await Http.put(`/football/matches/${match_id}/timeline-mode`, { timeline_mode })
    },
    async setTimelineSettings(match_id, data) {
        return await Http.put(`/football/matches/${match_id}/timeline-mode`, data)
    },
}
